import React, { FC } from "react";

import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import Box from "@mui/material/Box";
import { SATOSContentRender } from "@/components/Application/SATOSContentRender";
import { useFetchChecklistVersionsComparison } from "@/components/Procedures/API/ChecklistQueries";

interface ChecklistComparisonDialogueProps {
	checklistId: number;
	nodeId: number;
	procedureId: number;
	open: boolean;
	handleClose: (open: boolean) => void;
}

export const ChecklistComparisonDialogue: FC<ChecklistComparisonDialogueProps> = (props) => {
	const { data, isLoading } = useFetchChecklistVersionsComparison(
		props.checklistId, props.nodeId, props.procedureId, props.open
	);

	if (isLoading || !data) {
		return (
			<StyledDialog
				open={props.open}
				handleClose={() => props.handleClose(false)}
			>
				<DialogContent sx={{ height: "100%" }}>
					<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
						<CircularProgress sx={(theme) => ({ color: theme.palette.grey[400] })}/>
					</Box>
				</DialogContent>
			</StyledDialog>
		);
	} else {
		return (
			<StyledDialog
				open={props.open}
				handleClose={() => props.handleClose(false)}
			>
				<DialogContent sx={{ height: "100%" }}>
					<DialogContentText id="alert-dialog-slide-description">
						<SATOSContentRender content={data.Summary} />
					</DialogContentText>
				</DialogContent>
			</StyledDialog>
		);
	}
};

interface StyledDialogProps {
	open: boolean;
	handleClose: (open: boolean) => void;
}

export const StyledDialog: FC<StyledDialogProps> = (props) => {
	return (
		<Dialog
			open={props.open}
			keepMounted
			onClose={() => props.handleClose(false)}
			aria-describedby="alert-dialog-slide-description"
			scroll="body"
			PaperProps={{ sx: { position: "absolute", right: "-8px", top: "390px", width: "600px", minHeight: "200px" }}}
		>
			{props.children}
		</Dialog>
	);
}